export const ROLE_COLUMNS = [
  { id: 'actions', title: '', className: 'w-32' },
  { id: 'id', title: 'id' },
  { id: 'name', title: 'role_name' },
  { id: 'access', title: 'access', className: 'last:text-left' },
];

export const checkboxTitles = ['access', 'view', 'viewAny', 'create', 'update', 'delete'];
